import React from 'react';
import PropTypes from 'prop-types';
import { propTypes } from 'shared/proptypes/Company';
import CompanyHeader from './Header';
import styles from './NoImageHeader.module.scss';

const CompanyNoImageHeader = ({ company }) => (
  <div className="container">
    <div className="row">
      <div className="col-12">
        <div className={styles.header}>
          <CompanyHeader
            alignInfoTop
            company={company}
          />
        </div>
      </div>
    </div>
  </div>
);

CompanyNoImageHeader.propTypes = {
  company: PropTypes.shape({ ...propTypes, description: PropTypes.string }).isRequired
};

export default CompanyNoImageHeader;
